<template>
  <div class="honour-list">
    <div class="honour-item"
         v-for="(item, index) in list"
         :key="index"
    >
      <div class="item-info">
        <ym-avatar class="user-avatar"
                   size="small"
                   :avatar="item.user.avatar"
        />
        <div class="info">
          <div class="user-name">{{ item.user.name }}</div>
          <div class="content"
               v-html="item.content"
          ></div>
          <template v-if="handleShowTool(item) === 'showToolBtn'">
            <div class="tool-block">
              <ym-button class="course"
                         size="extra-small"
                         type="primary"
                         plain
                         @click="handleProductDetail(item.product.url)"
              >
                所属课程
              </ym-button>
              <ym-button size="extra-small"
                         type="primary"
                         @click="handleProductDetail(item.work.url)"
              >
                TA的作品
              </ym-button>
            </div>
          </template>
          <template v-if="handleShowTool(item) === 'showCourseTool'">
            <div class="item-product"
                 @click="handleProductDetail(item.product.url)"
            >
              <span class="title">{{ item.product.title }}</span>
              <ym-icon class="ym-icon"
                        name="right"
              />
            </div>
          </template>
          <template v-if="handleShowTool(item) === 'showWorkTool'">
            <div class="item-product"
                 @click="handleProductDetail(item.work.url)"
            >
              <span class="title">{{ item.work.title }}</span>
              <ym-icon class="ym-icon"
                        name="right"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import Avatar from '@/components/Avatar';
  import { locationHref } from '@/utils';

  export default {
    name: 'HonourList',
    components: {
      'ym-avatar': Avatar,
      'ym-button': Button,
    },
    data() {
      return {
        data: [],
      };
    },
    props: {
      list: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
    },
    watch: {
      list(val) {
        this.data = val;
      },
    },
    methods: {
      handleProductDetail(url) {
        locationHref(url);
      },
      handleShowTool(item) {
        // if (item.product.url === '' && item.work.url === '') return 'hideToolBar';
        if (item.product.url !== '' && item.work.url !== '') return 'showToolBtn';
        if (item.product.url !== '') return 'showCourseTool';
        if (item.work.url !== '') return 'showWorkTool';
        return false;
      },
    },
    created() {
      this.data = this.list;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .honour-list {
    padding: @size-base;
    background: @color-white;
  }

  .honour-item {
    padding: @size-base 0;
    border-bottom: @border-base;
  }
  .item-info {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .user-avatar {
    margin-right: @size-small;
  }
  .info {
    font-size: @font-size-base;
    line-height: 1.4;
    color: @color-text-base;
  }
  .user-name {
    margin: @size-extra-small 0;
    line-height: 1;
    color: @color-text-light;
  }
  .content {
    line-height: 1.4;
    /deep/ img, /deep/ video {
      max-width: 100%;
    }
  }
  .item-product {
    width: 100%;
    margin-top: @size-small;
    padding: (@size-extra-small + @size-extra-small / 2) @size-small;
    box-sizing: border-box;
    border-radius: @border-radius-base;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: @background-color-base;
    color: @color-text-lighter;
    font-size: @font-size-small;
    .title {
      line-height: 1.3;
      color: @color-primary;
    }
    .ym-icon {
      font-size: @font-size-base;
      color: @color-gray-light;
    }
  }
  .tool-block {
    width: 100%;
    margin-top: @size-small;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .course {
      margin-right: @size-small;
    }
  }

</style>
